<template>
    <div>
        <opening-period-top-alert :field="field"></opening-period-top-alert>

        <div class="row">
            <opening-period-table v-for="(period, index) in provider.opening_periods"
                                  :period="period"
                                  :index="index">
            </opening-period-table>

            <add-button></add-button>

            <add-period-modal></add-period-modal>
        </div>
    </div>
</template>

<script>

import {mapGetters, mapMutations, mapState} from "vuex"
import {fieldsMapping} from "../../../../../static/webform"
import OpeningPeriodTopAlert from "./OpeningPeriodTopAlerts.vue"
import OpeningPeriodTable from "./OpeningPeriodTable.vue"
import AddButton from "./AddButton.vue"
import AddPeriodModal from "./AddPeriodModal.vue"

export default {
    name: "FormOpeningPeriod",
    props: ['field'],
    components: {AddPeriodModal, AddButton, OpeningPeriodTable, OpeningPeriodTopAlert},
    methods: {
        ...mapMutations('web_form', ['updateProviderFieldValue']),
        initPeriods() {
            this.provider.opening_periods.forEach((period) => {
                if (period.opening_days === undefined) {
                    period.opening_days = [
                        {closed: true, day_of_week: 0},
                        {closed: true, day_of_week: 1},
                        {closed: true, day_of_week: 2},
                        {closed: true, day_of_week: 3},
                        {closed: true, day_of_week: 4},
                        {closed: true, day_of_week: 5},
                        {closed: true, day_of_week: 6},
                    ]
                }

                period.uid = Math.random().toString(36).substr(2, 16)

                period.opening_days.forEach((day) => {
                    if (day.opening_hours === undefined) {
                        this.$set(day, "opening_hours", [{open: null, close: null}])
                    }

                    if (day.opening_hours.length === 0) {
                        day.opening_hours.push({open: null, close: null})
                    }
                })
            })
        }
    },
    computed: {
        ...mapState("webFormStyle", ["fieldsColor", "primaryColor"]),
        ...mapState("web_form", ['submitted', 'provider']),
        ...mapGetters('web_form', ['getCodeFromField', 'getProviderFieldValue']),
        fieldCode() {
            return this.getCodeFromField(this.field)
        },
        path() {
            return fieldsMapping.find(path => path.code === this.fieldCode)
        },
        fieldValue() {
            let value = this.getProviderFieldValue(this.path)

            return this.formatDate(value, false)
        },
        placeholder() {
            return this.path.placeholder !== undefined ? this.path.placeholder : null
        }
    },
    created() {
        this.initPeriods()
    }
}
</script>